//navbar links can be added here. 
export const MenuItems = [
    {
        title: 'About',
        url: './home#about',
        cName: 'nav-links'
    },
    {
        title: 'Find Healers',
        url: './search',
        cName: 'nav-links'
    }
    // },
    // {
    //     title: 'Schedule',
    //     url: './schedule',
    //     cName: 'nav-links'
    // }
    // ,
    // {
    //     title: 'Messages',
    //     url: './messages',
    //     cName: 'nav-links'
    // }
];